import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../stylesheets/style.scss";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import { Col, Button, FormGroup, Label, Input, Spinner } from "reactstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import {
	faCalendarAlt,
	faWindowClose,
} from "@fortawesome/free-solid-svg-icons";
import { Resource_APIs } from "./Resource_APIs";
import { Ticket_Variables } from "../variables/Ticket_Variables";
import { UserConsumer } from "../../../UserContext";
import Header from "../../timesheetModule/Header";
import CustomReactSelect from "../../../components/CustomReactSelect";
import { AlertPopups } from "../../../components/AlertPopups";
import { Routes } from "../../../configurations/config";
const validation = Yup.object().shape({
	assigneeDept: Yup.string()
		.required("Select Department")
		.typeError("Invalid input")
		.nullable(),
	selectItems: Yup.mixed()
		.required("Select any item")
		.typeError("Invalid input"),
	selectUrgency: Yup.string()
		.required("Select Priority")
		.typeError("Invalid input")
		.nullable(),
	datePicker: Yup.date().required("Select Date").typeError("Invalid input"),
	Description: Yup.string()
		.required("Description is required")
		.typeError("Invalid input")
		.max(500, "Max 500 characters allowed"),
	alternateItem: Yup.mixed().when("selectItems", {
		is: (selectItems) => {
			if (selectItems !== null) {
				return selectItems.value === 0;
			}
		},
		then: Yup.string()
			.required("Alternate ticket item is required")
			.max(25, "Max 25 characters allowed")
			.typeError("Invalid value")
			.nullable(),
	}),
});
let token = null,
	userId = null;
class Ticket extends Component {
	constructor(props) {
		super(props);
		this.state = {
			assigneeDept: null,
			assigneePerson: null,
			selectItems: null,
			selectUrgency: null,
			Description: "",
			attachment: "",
			datePicker: "",
			persons: [],
			departments: [],
			employees: [],
			items: [],
			deptId: "",
			date: new Date().toDateString(),
			alternateItem: "",
			hidden: true,
			fileErr: false,
			loading: false,
		};
	}
	componentDidMount() {
		var headers = {
			Authorization: `Bearer ${token}`,
		};
		axios
			.get(`${Resource_APIs.GetAllDepartments_API}`, {
				headers: headers,
			})
			.then((res) => {
				this.setState({ departments: res.data });
			});
	}

	departmentListValues() {
		let departments = this.state.departments;
		departments.sort(function (a, b) {
			var textA = a.name.toUpperCase();
			var textB = b.name.toUpperCase();
			return textA < textB ? -1 : textA > textB ? 1 : 0;
		});
		return departments.map((data) => ({
			label: data.name,
			value: data.id,
		}));
	}
	employeeListValues() {
		return this.state.employees
			.map((data) => ({
				label: data.employeeName,
				value: data.employeeId,
			}))
			.sort((a, b) => a.label.localeCompare(b.label));
	}
	itemsListValues() {
		return this.state.items
			.map((data) => ({
				label: data.name,
				value: data.ticketItemId,
			}))
			.sort((a, b) => a.label.localeCompare(b.label));
	}

	openDatepicker = () => this._calendar.setOpen(true);

	handleChange = (temp, displayCode, event) => {
		if (displayCode === 1) {
			this.setState({
				[event.name]: temp,
				assigneePerson: null,
				selectItems: null,
				hidden: true,
				alternateItem: "",
			});
			var headers = {
				Authorization: `Bearer ${token}`,
			};
			axios
				.get(
					`${Resource_APIs.GetDepartmentEmployees_API}${temp.value}`,
					{
						headers: headers,
					}
				)
				.then((res) => {
					this.setState({ employees: res.data });
				});
			axios
				.get(`${Resource_APIs.GetDepartmentItems_API}${temp.value}`, {
					headers: headers,
				})
				.then((res) => {
					this.setState({ items: res.data });

					this.state.items.push(Ticket_Variables.others);
				});
		} else if (
			displayCode === 2 ||
			displayCode === 3 ||
			displayCode === 5
		) {
			this.setState({
				[event.name]: temp,
			});

			if (displayCode === 3)
				this.setState({
					hidden: temp.value === 0 ? false : true,
					alternateItem:
						temp.value === 0 ? this.state.alternateItem : "",
				});
		} else if (displayCode === 4 || displayCode === 7) {
			this.setState({
				[temp.target.name]: temp.target.value.replace(
					new RegExp(`^\d{1,3}(?:,\d{3})*$`)
				),
			});
		} else if (displayCode === 6) {
			this.setState({
				datePicker: temp,
			});
		} else if (displayCode === 8) {
			if (temp.target.files[0] !== undefined) {
				this.setState({ fileErr: false });
				if (
					["image/jpeg", "image/jpg", "image/png"].includes(
						temp.target.files[0].type
					)
				) {
					this.setState({
						attachment: temp.target.files[0],
					});
				} else {
					this.setState({
						fileErr: true,
					});
				}
			}
		} else if (displayCode === 9) {
			document.getElementById("attachment").value = null;
			this.setState(
				{
					attachment: "",
				},
				() => {
					if (document.getElementById("icon")) {
						document.getElementById("icon").remove();
					}
				}
			);
		}
	};
	handleCancel = () => {
		AlertPopups.confirmBox
			.fire({
				text: `${AlertPopups.cancelMsg}`,
			})
			.then((result) => {
				if (result.value) {
					this.props.history.push(Routes.MyTickets);
				}
			});
	};
	handleSubmit = (values) => {
		if (this.state.fileErr === false) {
			AlertPopups.confirmBox
				.fire({
					text: `${AlertPopups.createTicketConfirm}`,
				})
				.then((result) => {
					if (result.value) {
						let self = this;
						let formdata = new FormData();
						formdata.append("CreatedBy", userId);
						formdata.append(
							"DepartmentId",
							values.assigneeDept.value
						);
						if (values.assigneePerson !== null) {
							formdata.append(
								"AssignedTo",
								values.assigneePerson.value
							);
						}
						values.alternateItem !== "" &&
							formdata.append(
								"alternateTicketItem",
								values.alternateItem
							);
						formdata.append("ItemId", values.selectItems.value);
						formdata.append("Priority", values.selectUrgency.value);
						formdata.append(
							"ExpectedDate",
							moment(
								values.datePicker,
								"ddd MMM DD YYYY HH:mm:ss"
							).format("YYYY-MM-DDTHH:mm:00.000")
						);
						formdata.append(
							"ExpectedTime",
							moment(
								values.datePicker,
								"ddd MMM DD YYYY HH:mm:ss"
							).format("YYYY-MM-DDTHH:mm:00.000")
						);
						formdata.append("Details", values.Description);
						if (this.state.attachment !== null) {
							formdata.append(
								"AttachedFileName",
								this.state.attachment
							);
						}

						var headers = {
							Authorization: `Bearer ${token}`,
						};
						this.setState({ loading: true });
						axios
							.post(`${Resource_APIs.PutTicket_API}`, formdata, {
								headers: headers,
							})
							.then(function (response) {
								self.setState({ loading: false });

								if (response.status === 200) {
									AlertPopups.successAlert.fire({
										text: `${AlertPopups.successMsg}`,
									});
									self.props.history.push(Routes.MyTickets);
								}
							})
							.catch((error) => {
								AlertPopups.WarningAlert.fire({
									text: `Try again please`,
								});
								self.setState({ loading: false });
							});
					}
				});
		}
	};
	render() {
		return (
			<div className="container-fluid pl-3 pr-3">
				<Header
					title="Create Ticket"
					onClick={() => {
						this.props.history.push(Routes.MyTickets);
					}}
				/>
				<UserConsumer>
					{(userDetails) => {
						token = userDetails.token;
						userId = userDetails.id;

						return (
							<Formik
								initialValues={this.state}
								enableReinitialize={true}
								onSubmit={(values) => this.handleSubmit(values)}
								validationSchema={validation}
								validateOnChange={true}
							>
								{({ errors, handleSubmit }) => (
									<form
										onSubmit={handleSubmit}
										className="itemReqForm"
									>
										<FormGroup
											row
											id="row0"
											className="bottom-spacing topBorders"
										>
											<Label sm={12}>Create Ticket</Label>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle1"
										>
											<Label for="assigneeDept" sm={2}>
												Department
												<span className="required">
													*
												</span>
											</Label>
											<Col sm={10}>
												<CustomReactSelect
													options={this.departmentListValues()}
													name="assigneeDept"
													id="assigneeDept"
													placeholder=""
													bsSize="sm"
													styles={
														Ticket_Variables.react_select_style
													}
													onChange={(value, event) =>
														this.handleChange(
															value,
															1,
															event
														)
													}
													value={
														this.state.assigneeDept
													}
													className={`formValueInput ${
														errors.assigneeDept
															? "h-auto invalid"
															: "h-auto"
													}`}
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle2"
										>
											<Label for="assigneePerson" sm={2}>
												Assign To
											</Label>
											<Col sm={10}>
												<CustomReactSelect
													options={this.employeeListValues()}
													name="assigneePerson"
													id="assigneePerson"
													placeholder=""
													bsSize="sm"
													isClearable
													styles={
														Ticket_Variables.react_select_style
													}
													onChange={(value, event) =>
														this.handleChange(
															value,
															2,
															event
														)
													}
													className={`formValueInput`}
													value={
														this.state
															.assigneePerson
													}
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing rowStyle1"
										>
											<Label for="selectItems" sm={2}>
												Select Item
												<span className="required">
													*
												</span>
											</Label>
											<Col sm={10}>
												<CustomReactSelect
													options={this.itemsListValues()}
													name="selectItems"
													id="selectItems"
													bsSize="sm"
													styles={
														Ticket_Variables.react_select_style
													}
													placeholder=""
													onChange={(value, event) =>
														this.handleChange(
															value,
															3,
															event
														)
													}
													value={
														this.state.selectItems
													}
													className={`formValueInput ${
														errors.selectItems
															? "h-auto invalid"
															: "h-auto"
													}`}
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											id="alternateItemCol"
											className="bottom-spacing rowStyle2"
											hidden={this.state.hidden}
										>
											<Label for="alternateItem" sm={2}>
												Alternate Item
												<span className="required">
													*
												</span>
											</Label>
											<Col sm={10}>
												<Input
													type="text"
													value={
														this.state.alternateItem
													}
													name="alternateItem"
													id="alternateItem"
													bsSize="sm"
													maxLength="25"
													autoComplete="off"
													onChange={(value, event) =>
														this.handleChange(
															value,
															4,
															event
														)
													}
													className={
														errors.alternateItem
															? "invalid"
															: ""
													}
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className={`bottom-spacing  ${
												this.state.hidden
													? "rowStyle2"
													: "rowStyle1"
											}`}
										>
											<Label for="selectUrgency" sm={2}>
												Priority
												<span className="required">
													*
												</span>
											</Label>
											<Col sm={10}>
												<CustomReactSelect
													options={
														Ticket_Variables.UrgencyValues
													}
													name="selectUrgency"
													id="selectItems"
													placeholder=""
													bsSize="sm"
													styles={
														Ticket_Variables.react_select_style
													}
													onChange={(value, event) =>
														this.handleChange(
															value,
															5,
															event
														)
													}
													value={
														this.state.selectUrgency
													}
													className={`formValueInput ${
														errors.selectUrgency
															? "h-auto invalid"
															: "h-auto"
													}`}
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className={`bottom-spacing  ${
												this.state.hidden
													? "rowStyle1"
													: "rowStyle2"
											}`}
											style={{ width: "100%" }}
										>
											<Label for="datePicker" sm={2}>
												Due Date & Time
												<span className="required">
													*
												</span>
											</Label>
											<div
												style={{ fontWeight: "normal" }}
												className="col-sm-10"
											>
												<Col className="datepicker-wrapper pl-1 pr-2">
													<DatePicker
														showYearDropdown
														showMonthDropdown
														dateFormatCalendar=" " //for title
														value={
															this.state
																.datePicker
														}
														name="datePicker"
														id="datePicker"
														bsSize="sm"
														selected={
															this.state
																.datePicker
														}
														onChange={(
															value,
															event
														) =>
															this.handleChange(
																value,
																6,
																event
															)
														}
														onChangeRaw={(e) => {
															e.preventDefault();
														}}
														className={
															errors.datePicker
																? "px-2 invalid"
																: "px-2"
														}
														autoComplete="off"
														dateFormat="dd/MM/yyyy h:mm a"
														disabledKeyboardNavigation
														minDate={new Date()}
														showTimeSelect
														ref={(c) =>
															(this._calendar = c)
														}
													/>
													<FontAwesomeIcon
														icon={faCalendarAlt}
														className="calender-icon"
														color="keppel"
														onClick={
															this.openDatepicker
														}
													/>
												</Col>
											</div>
										</FormGroup>
										<FormGroup
											row
											className={`bottom-spacing  ${
												this.state.hidden
													? "rowStyle2"
													: "rowStyle1"
											}`}
										>
											<Label for="Description" sm={2}>
												Description
												<span className="required">
													*
												</span>
											</Label>
											<Col sm={10}>
												<Input
													type="textarea"
													name="Description"
													id="Description"
													className={
														errors.Description
															? "h-auto invalid"
															: "h-auto"
													}
													onChange={(value, event) =>
														this.handleChange(
															value,
															7,
															event
														)
													}
													value={
														this.state.Description
													}
													maxLength="500"
												/>
											</Col>
										</FormGroup>
										<FormGroup
											row
											className={`bottom-spacing lastRow ${
												this.state.hidden
													? "rowStyle1"
													: "rowStyle2"
											}`}
										>
											<Label for="attachment" sm={2}>
												Attachment
											</Label>
											<Col sm={9} id="attachment-align">
												<Input
													type="file"
													name="attachment"
													id="attachment"
													accept="image/png,image/jpeg,image/jpg"
													onChange={(value, event) =>
														this.handleChange(
															value,
															8,
															event
														)
													}
													className="overflow-hidden"
												/>
												{this.state.fileErr && (
													<div className="input-feedback">
														Only
														".jpeg",".jpg",".png"
														type files allowed
													</div>
												)}
											</Col>
											<Col sm={1}>
												<FontAwesomeIcon
													icon={faWindowClose}
													className="att-remove-icon"
													color="keppel"
													onClick={(value, event) =>
														this.handleChange(
															value,
															9,
															event
														)
													}
													hidden={
														!this.state.attachment
													}
												/>
											</Col>
										</FormGroup>
										<div className="btns mt-3">
											<Button
												className="submit-btn leftBtn"
												type="Submit"
											>
												Create
											</Button>
										</div>
									</form>
								)}
							</Formik>
						);
					}}
				</UserConsumer>

				{this.state.loading && (
					<div className="loader-div">
						<Spinner color="secondary" />
					</div>
				)}
			</div>
		);
	}
}
export default Ticket;
